import styled from '@emotion/styled';

export const StyledBrandWrapper = styled.div`
  .logo-company {
    position: absolute;
    top: 3.13rem;
    left: 3.44rem;
  }
  .logo-product {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .logo-work {
    position: absolute;
    right: 3.81rem;
    bottom: 3.13rem;
  }
`;
